module.exports = __webpack_public_path__ + "static/img/wechat.45d1ab04.jpeg";